// Last-known-good game data, kept on the device so an API outage mid-game
// doesn't leave players staring at "Failed to load game" with a scorecard they
// can no longer see. Scores are the one thing here that is painful to
// reconstruct, so they are worth persisting locally.

const gameKey = (id) => `game-cache:${id}`;
const pendingKey = (id) => `game-pending:${id}`;

function read(key) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function write(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // Quota exceeded or storage disabled (private browsing). Caching is a
    // best-effort enhancement, so never let it break the game.
  }
}

export function cacheGame(id, game) {
  if (id && game) write(gameKey(id), game);
}

export function readCachedGame(id) {
  return id ? read(gameKey(id)) : null;
}

// A state the server hasn't accepted yet. Survives a refresh or a crash, so the
// retry can still land after the outage clears.
export function setPendingState(id, state) {
  if (id) write(pendingKey(id), state);
}

export function readPendingState(id) {
  return id ? read(pendingKey(id)) : null;
}

export function clearPendingState(id) {
  try {
    if (id) localStorage.removeItem(pendingKey(id));
  } catch (e) {
    // ignore
  }
}
